import { 
  useEffect, 
  useState,
} from "react";

export function useBodyResize(ref: React.RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number>(ref.current?.clientWidth);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      setWidth(ref.current?.clientWidth);
    });

    observer.observe(document.body);

    return () => observer.disconnect();
  }, [ref]);

  return width || 0;
}
